import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Loader } from "../components/Primitives";
import { CheckCircle2, Circle } from "lucide-react";

const SDF_CHECKS = [
  { key: "dpo_appointed", label: "Data Protection Officer appointed (India-resident)" },
  { key: "independent_auditor", label: "Independent data auditor engaged" },
  { key: "annual_dpia", label: "Annual DPIA program in place" },
  { key: "annual_audit", label: "Annual DPDP audit conducted" },
  { key: "algorithmic_due_diligence", label: "Algorithmic due diligence conducted for automated decisioning / profiling" },
  { key: "periodic_compliance_review", label: "Periodic compliance review by DPO with board reporting" },
  { key: "board_reports", label: "Board-ready DPDP compliance reports maintained" },
  { key: "additional_security_controls", label: "Additional security and governance controls (encryption, access, logging)" },
  { key: "traffic_data_restrictions", label: "Where applicable, restrictions on traffic data or localization considered" },
];

export default function SDFReadiness() {
  const [profile, setProfile] = useState(null);
  useEffect(() => { api.get("/org/profile").then(r => setProfile(r.data)); }, []);
  if (!profile) return <Loader />;

  return (
    <div>
      <PageHeader
        title="SDF Readiness"
        description="Significant Data Fiduciary obligations — track readiness even if not yet designated."
        testId="sdf-page-header"
      />

      <div className="mb-4 border border-blue-200 bg-blue-50 rounded-md p-4 text-sm text-blue-900">
        Designated as SDF: <strong>{profile.sdf_designated ? "Yes" : "No"}</strong>. Track readiness regardless of current designation.
      </div>

      <div className="bg-white border border-slate-200 rounded-md p-5">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">SDF Readiness Checklist</div>
        <div className="space-y-3">
          {SDF_CHECKS.map((c, i) => (
            <div key={c.key} className="flex items-start gap-3 border-b border-slate-100 pb-3 last:border-0">
              <Circle className="w-4 h-4 text-slate-300 mt-0.5" />
              <div className="flex-1">
                <div className="text-sm text-slate-900 font-medium">{i + 1}. {c.label}</div>
              </div>
              <span className="text-[10px] uppercase tracking-wider text-slate-500">Track in respective module</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
